import { AnyAction } from 'redux';
import { RESET_STATE, GET_ALL_ORGANIZATIONS, SET_ORGS_COUNT, GET_ORGANIZATION } from '@app/store/constants';

const initialState = {
    count: 0,
    orgs: [],
    organization: {}

};

export function orgs(state = initialState, action: AnyAction) {
    const { payload, type } = action;

    switch (type) {
        case RESET_STATE:
            return initialState;

        case GET_ALL_ORGANIZATIONS:
            return {
                ...state,
                orgs: payload
            };

        case SET_ORGS_COUNT:
            return {
                ...state,
                count: payload
            };

        case GET_ORGANIZATION:
            return {
                ...state,
                organization: payload
            };

        default:
            return state;
    }
}
